import { render, staticRenderFns } from "./chat_circle.vue?vue&type=template&id=06ce1965&scoped=true"
import script from "./chat_circle.vue?vue&type=script&lang=js"
export * from "./chat_circle.vue?vue&type=script&lang=js"
import style0 from "./chat_circle.vue?vue&type=style&index=0&id=06ce1965&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce1965",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
